import { combineReducers } from 'redux'
import userDataReducer from './userDataReducer'
import organisationDataReducer from './organisationDataReducer'
import examDataReducer from './examDataReducer'
import BatchDataReducer from './batchDataReducer'
import QuestionDataReducer from './questionReducer'
import DashboardDataReducer from './dashboardReducer'
import attendExamReducer from './attendExamReducer'
import reportQuestionReducer from './reportQuestionReducer'
import examReportDataReducer from './examReportDataReducer'
import NotificationDataReducer from './notificationDataReducer'
import employeeManagementReducer from './employeeManagementReducer'
import branchDataReducer from './branchDataReducer'
import smeDashboardReducer from './smeDashboardReducer'
import corporateAdminDashboardReducer from './corporateAdminDashboardReducer'
import registerCandidate from './registerCandidate'
import jobRoleReducer from './jobRoleReducer'
import proctoringReducer from './proctoringReducer'
import resumeLibraryReducer from './resumeLibraryReducer'
import recruitmentAgenciesReducer from './recruitmentAgenciesReducer'
import companyDetailsReducer from './companyDetailsReducer'

// Combine all reducers as root reducer
export default combineReducers({
  recruitmentAgenciesReducer,
  userDataReducer,
  organisationDataReducer,
  examDataReducer,
  BatchDataReducer,
  QuestionDataReducer,
  DashboardDataReducer,
  attendExamReducer,
  reportQuestionReducer,
  examReportDataReducer,
  NotificationDataReducer,
  employeeManagementReducer,
  branchDataReducer,
  smeDashboardReducer,
  corporateAdminDashboardReducer,
  registerCandidate,
  jobRoleReducer,
  proctoringReducer,
  resumeLibraryReducer,
  companyDetailsReducer,
})
